import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CLEAR_ALL_STATE,
  PDF_PAGE_LEFT_POSITIONS_SET,
} from '@app/libs/reactPdfJs/store/actionTypes';

export type PdfPageLeftPositionsState = number[];

const initialState: PdfPageLeftPositionsState = [];

export default function reducer(
  state: PdfPageLeftPositionsState = initialState,
  action: PdfAction
) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case PDF_PAGE_LEFT_POSITIONS_SET:
      return action.payload;
    default:
      return state;
  }
}
